import * as Yup from 'yup';
import React from 'react';
import { Formik } from 'formik';
import { FaMeta } from 'react-icons/fa6';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Field from 'legacy/common/components/wysiwyg-form/Field';

interface MetaPixelModalProps {
  initialValues: { metaPixelId: string };
  onClose: () => void;
  onSave: (label: string) => void;
}

const MetaPixelSchema = Yup.object().shape({
  metaPixelId: Yup.string()
});

const MetaPixelModal: React.FC<MetaPixelModalProps> = ({
  initialValues,
  onClose,
  onSave
}) => {
  const onSubmit = (values) => {
    onSave(values.metaPixelId);
    onClose();
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize
      validationSchema={MetaPixelSchema}
    >
      {({ submitForm }) => (
        <Modal
          type={ModalType.SMALL}
          onClose={onClose}
          autoHeight
          visible
          icon={<FaMeta size={20} />}
          title="Meta Pixel ID"
          renderFooter={() => (
            <Button type={ButtonType.Primary} onClick={submitForm}>
              Save Meta Pixel ID
            </Button>
          )}
        >
          <p className="px-6 pt-6 text-base font-normal">
            Add a Meta Pixel ID here to track web traffic and purchasers on your
            Event Page. Use this data to retarget visitors later with ads on
            Facebook and Instagram.
          </p>
          <div className="px-4 pt-6">
            <Field
              type="text"
              label="Meta Pixel ID"
              id="metaPixelId"
              name="metaPixelId"
              clearable
              placeholder="e.g. 1234567890"
            />
          </div>
        </Modal>
      )}
    </Formik>
  );
};

export default MetaPixelModal;
